/**
 * UTM Parameter Tracker
 *
 * Captures UTM parameters and ad click identifiers from the landing page URL and
 * stores them as first-party cookies. Uses first-touch attribution: if cookies are
 * already set (from a previous visit), they are left untouched — so a visitor who
 * converts on page 2 or 3, or returns days later, still carries the original
 * campaign data.
 *
 * Cookie lifetime: 30 days.
 *
 * Cookie names (configure these in Formie hidden fields → Default Value → Cookie):
 *   nd_utm_source       — e.g. google, facebook, instagram
 *   nd_utm_medium       — e.g. cpc, social, email
 *   nd_utm_campaign     — campaign name or ID
 *   nd_utm_term         — keyword (optional)
 *   nd_utm_content      — ad variant / creative (optional)
 *   nd_utm_landing_page — the path of the first page the visitor landed on (e.g. /producten/lichtreclame)
 *   nd_gclid            — Google Click ID (auto-appended by Google Ads)
 *   nd_fbclid           — Facebook Click ID (auto-appended by Meta Ads)
 */

const COOKIE_PREFIX = 'nd_';
const COOKIE_DAYS = 30;

const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const CLICK_ID_PARAMS = ['gclid', 'fbclid'];
const ALL_TRACKED_PARAMS = [...UTM_PARAMS, ...CLICK_ID_PARAMS];

function cookieName(param) {
    return COOKIE_PREFIX + param;
}

function getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}

function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
}

const params = new URLSearchParams(window.location.search);
const hasTrackedParams = ALL_TRACKED_PARAMS.some(p => params.has(p));

if (hasTrackedParams) {
    ALL_TRACKED_PARAMS.forEach(param => {
        const value = params.get(param);
        const name = cookieName(param);
        // First-touch: only write if the cookie isn't already set
        if (value && !getCookie(name)) {
            setCookie(name, value, COOKIE_DAYS);
        }
    });

    const landingPageCookie = cookieName('utm_landing_page');
    if (!getCookie(landingPageCookie)) {
        setCookie(landingPageCookie, window.location.pathname, COOKIE_DAYS);
    }
}
